
  import notifications from '~/mixins/pages/mission-control/notifications'
  export default {
    name: 'Theme4DesktopNotification',
    mixins: [notifications]
  }
